
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlayCircleIcon from "@mui/icons-material/PlayCircleFilled";
import ArticleIcon from "@mui/icons-material/Article";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ScienceIcon from "@mui/icons-material/Science";
import { useParams, useNavigate } from "react-router-dom";

import TopBar from "./topbar";
import Footer from "./footer";

export default function ResourceDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResource = async () => {
      try {
        const res = await fetch(
          `https://backend-global-1vq9.onrender.com/api/resources/${id}`
        );
        const data = await res.json();
        setResource(data);
      } catch (error) {
        console.error("Failed to fetch resource details", error);
      } finally {
        setLoading(false);
      }
    };

    fetchResource();
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!resource) {
    return (
      <Typography sx={{ textAlign: "center", mt: 10 }}>
        Resource not found.
      </Typography>
    );
  }

  const iconMap = {
    video: <PlayCircleIcon sx={{ fontSize: 60, color: "#F57E47" }} />,
    article: <ArticleIcon sx={{ fontSize: 60, color: "#00AEEF" }} />,
    template: <InsertDriveFileIcon sx={{ fontSize: 60, color: "#00AEEF" }} />,
    "case-study": <ScienceIcon sx={{ fontSize: 60, color: "#6C6C6C" }} />,
  };

  return (
    <Box sx={{ px: 4, py: 4 }}>
        <TopBar/>
      <Button
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 3, textTransform: "none", fontWeight: "bold" }}
        onClick={() => navigate(-1)}
      >
        Back to Library
      </Button>

      <Card sx={{ borderRadius: 3, p: 3 }}>
        <CardContent>
          <Stack direction="row" spacing={3} alignItems="center">
            {iconMap[resource.type]}

            <Box>
              <Typography variant="h5" fontWeight="bold">
                {resource.title}
              </Typography>

              <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                {resource.category}
              </Typography>

              <Box
                sx={{
                  background:
                    resource.type === "video"
                      ? "linear-gradient(180deg, #F57E47, #F36421)"
                      : "linear-gradient(180deg, #6BD0F6, #00AEEF)",
                  padding: "4px 10px",
                  borderRadius: 1,
                  display: "inline-block",
                  mt: 1,
                }}
              >
                <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: "bold" }}>
                  {resource.type.charAt(0).toUpperCase() + resource.type.slice(1)}
                </Typography>
              </Box>
            </Box>
          </Stack>

          <Typography sx={{ mt: 3, fontSize: 15, maxWidth: 700 }}>
            {resource.description}
          </Typography>

          <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: "bold" }}
              onClick={() => window.open(resource.url, "_blank")}
            >
              Open Resource
            </Button>

            {resource.download && (
              <Button
                variant="outlined"
                sx={{ textTransform: "none", fontWeight: "bold" }}
                onClick={() => window.open(resource.download, "_blank")}
              >
                Download
              </Button>
            )}
          </Stack>
        </CardContent>
      </Card>
      <Footer/>
    </Box>
  );
}